import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import PbxContext from '../../context/PbxContext';
import Loading from '../../components/Loading/LoadingModule';
import EndpointsList from '../../components/Endpoints/EndpointsList';
import WebRTC from './components/WebRTC';
import Callcenter from '../Callcenter'
import { fetchEndpoints, accessLocalStorage, exportSelectAllEndpoints } from '../../services';


function Home() {
  const [loading, setLoading] = useState(true);
  const getItensStateGlobal = useContext(PbxContext);
  const { endpoints, setEndpoints, ipEndpoints, setIpEndpoints } = getItensStateGlobal;

  const history = useHistory();

  const getAllEndpointsConfig = async () => {
    const endpointsList = await exportSelectAllEndpoints();
    if(endpointsList === undefined) return setLoading(true);
    const elements = endpointsList.reduce((acc, cur) => {

      const getNameEndpoint = cur.callerid.split(' ');
      acc[`${cur.endpoint}`] = getNameEndpoint.length > 2 ? `${cur.callerid.split(' ')[0]} ${cur.callerid.split(' ')[1]}` : cur.callerid.split(' ')[0];
      return acc;
    },{})
    return elements;
  };

  const getApiEndpoints = useCallback(async () => {
    const endpointsFetcheds = await fetchEndpoints();
    const endpointsConfig = await getAllEndpointsConfig();

    const endpointsReceived = endpointsFetcheds.map((element) => {
      !isNaN(Number(element.resource)) ? element['name'] = endpointsConfig[`${element.resource}`] : element.resource;
      return element;
    });

    if (endpointsReceived) {
      setLoading(false);

      const dataUser = await accessLocalStorage.getUserLocalStorage();
      let { user: { endpointsviewer }} = dataUser;
      const visibility = endpointsviewer !== 'all' ? endpointsviewer.split(',') : [];

      const endpointsForViewer = visibility.length > 0 ? endpointsReceived.filter((endpoint) => {
        if(visibility.includes(endpoint.resource)) return endpoint;
      }) : endpointsReceived;
      setEndpoints(endpointsForViewer);

      
      return ipEndpoints;
    }
  }, [ipEndpoints]);

  const validateUserLogged = async () => {
    const dataUser = await accessLocalStorage.getUserLocalStorage();
    if (!dataUser) return history.push('/');
    await getApiEndpoints();
  }

  const fetchEvents = useCallback(async () => {
    const {
      REACT_APP_API_USER_AST,
      REACT_APP_API_PASS_AST
    } = process.env;

    const { ipRequest } = await accessLocalStorage.getUserLocalStorage();
    const ip = ipRequest.replace(/http/i, 'ws');

    const dbLocal = localStorage;
    const pbxEvents = new WebSocket(`${ip}ari/events?api_key=${REACT_APP_API_USER_AST}:${REACT_APP_API_PASS_AST}&app=pbxLogs&subscribeAll=true`);
    pbxEvents.onerror = await function error(error){ console.log(error); };


    pbxEvents.onmessage = (event) => {
      const obj = JSON.parse(event.data);

      if(obj.type === 'ContactStatusChange') {
        let ipEndpoint = obj.contact_info.uri.split('@')[1];
        ipEndpoint = ipEndpoint.split(':')[0];
        const nameEndpoint = obj.endpoint.resource;
        const stateEndpoint = obj.endpoint.state;
        // console.log(endpoints)
        const sendDbEndpoint = {
          endpoint: obj.endpoint.resource,
          name: endpoints[`${obj.endpoint.resource}`],
          state: obj.endpoint.state,
          ip: ipEndpoint,
        };
        if(stateEndpoint !== 'offline') dbLocal.setItem(nameEndpoint, JSON.stringify(sendDbEndpoint));
        if(stateEndpoint === 'offline') dbLocal.removeItem(nameEndpoint);
        setIpEndpoints(sendDbEndpoint)
      };

      if(obj.type === 'ChannelCreated') {
        const { channel: { caller: { number }, state } } = obj
        setIpEndpoints({
          endpoint: number,
          name: endpoints[`${number}`],
          state: state,
        });
      };

      if(obj.type === 'ChannelDestroyed') {
        const { channel: { caller: { number }, state } } = obj
        setIpEndpoints({
          endpoint: number,
          name: endpoints[`${number}`],
          state: state,
        });
      }
    }
  }, [setIpEndpoints])
  
  useEffect(() => {
    let cancel = false;
    validateUserLogged();

    return () => {
      cancel = true
    };
  }, [ipEndpoints])

  useEffect(() => {
    let cancel = false;
    fetchEvents();
    return () => {
      cancel = true
    };
  }, [fetchEvents]);

  return (
    <div>
      {
        loading ?
        <Loading />
        :
        <div className="App">
          <EndpointsList />
          <Callcenter />
          {/* <WebRTC /> */}
        </div>
      }
    </div>
  );
}

export default Home;
